import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { UserService } from '@app/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutGuard implements CanActivate {

  constructor(
    private userService: UserService
  ) { }

  canActivate(): boolean {

    this.userService.logOut(true);
    return false;
  }
}
